import { EParams, TMenu } from 'src/templates/TemplateLandingPage/TemplateLandingPage.types';

import { EMenuType } from 'src/components/LandingPage/MainMenu/MainMenu.types';

export const menuItems: TMenu = {
  default: [
    {
      route: EParams.OUR_APPROACH,
      title: 'Our Approach',
      initial: true,
    },
    {
      route: EParams.OUR_PRINCIPLES,
      title: 'Our Principles',
    },
    {
      route: EParams.OUR_TEAM,
      title: 'Our Team',
    },
    {
      route: EParams.JOIN_US,
      title: 'Join Us',
    },
  ],
  resources: [
    {
      route: EParams.TRENDING,
      title: 'Trending',
      initial: true,
    },
    // {
    //   route: EParams.NEWS,
    //   title: 'News',
    // },
    {
      route: EParams.READ,
      title: 'Read',
    },
    {
      route: EParams.WATCH,
      title: 'Watch',
    },
    {
      route: EParams.TALK_TO_US,
      title: 'Talk to us',
    },
  ],
};

export const backRoutePath = (page: string) => {
  const routesBack = {
    [EMenuType.DEFAULT]: `/company/${page}`,
    [EMenuType.RESOURCES]: `/resources/${page}`,
  };

  return routesBack;
};
